<template>
<v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
  <v-btn
    slot="activator"
    color="primary"
    flat
    :size="size"
    >
    <v-icon :size="size">{{ icon }}</v-icon>
  </v-btn>
  <v-card tile>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click.native="close">
        <v-icon>close</v-icon>
      </v-btn>
      <h3>{{ $t('message.post_new_message') }}</h3>
    </v-toolbar>
    <v-list>
      <v-list-tile avatar>
        <span slot="badge">3</span>
        <UserAvatar></UserAvatar>
        <v-list-tile-content>
            <v-list-tile-title>@{{ $auth.user().name }} <em class="caption">- {{ city }}</em></v-list-tile-title>
          </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-card-text>
      <alert></alert>
      <Camera sizeIcon="60" size="100%" icon="photo_camera" :tile="true"></Camera>
      <at-ta at="#" v-model="message" :allowSpaces="false" @at="handleAtHastags" :members="hastags">
        <at-ta v-model="message" :allowSpaces="false" @at="handleAt" :members="members">
          <div :class="{ 'error--text': errors.message }" class="v-input v-textarea v-text-field v-text-field--placeholder v-input--is-label-active v-input--is-dirty theme--light"><div class="v-input__control"><div class="v-input__slot"><div class="v-text-field__slot"><textarea :placeholder="placeholder" rows="5"></textarea></div></div><div class="v-text-field__details"><div class="v-messages theme--light"><div class="v-messages__wrapper"></div></div></div></div></div>
          <div v-if="errors.message" class="v-messages theme--light error--text"><div class="v-messages__wrapper"><div class="v-messages__message">{{ errors.message[0] }}</div></div></div>
        </at-ta>
      </at-ta>
      <v-btn :loading="isLoading" color="accent" @click="save">{{ $t('buttons.post_new_message') }}</v-btn>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
import event from '@/event'
import AtTa from 'vue-at/dist/vue-at-textarea'
const UserAvatar = () => import('@/components/particule/UserAvatar')
const Camera = () => import('@/components/camera/Camera')
const Alert = () => import('@/components/Alert.vue')

export default {
  name: 'PostNewMessage',

  data: () => ({
    message: '',
    isLoading: false,
    hastags: [],
    members: [],
    city: 'unkown',
    errors: [],
    dialog: false
  }),
  watch: {
    dialog: function () {
      this.loadCity()
      this.$ga.page({
        page: '/post-new-message',
        title: 'Post New Message',
        location: window.location.href
      })
    }
  },
  computed: {
    placeholder: function () {
      return this.$t('message.new_message_placeholder')
    },
    base64Data: function () {
      return this.$store.getters['Device/getBase64']
    },
    latitude: function () {
      return this.$store.getters['Geolocation/getLatitude'] // 46.5161278918636 // this.$store.getters['Geolocation/getLatitude']
    },
    longitude: function () {
      return this.$store.getters['Geolocation/getLongitude'] // 6.632778368693338 // this.$store.getters['Geolocation/getLongitude']
    }
  },
  props: {
    'size': {
      default: '25',
      type: String
    },
    'icon': {
      default: 'add_location',
      type: String
    },
    'reply': {
      default: 0,
      type: Number
    }
  },
  components: {
    Camera,
    Alert,
    AtTa,
    UserAvatar
  },
  methods: {
    async handleAt (chunk) {
      this.members = await this.$api.suggest.user({ 'user': chunk, 'limit': 5 }).then(response => {
        var cleanName = []
        response.data.forEach(function (user) {
          cleanName.push(user.name)
        })
        return cleanName
      })
    },
    async handleAtHastags (chunk) {
      this.hastags = await this.$api.suggest.hastag({ 'hashtag': chunk, 'limit': 5 }).then(response => {
        var cleanName = []
        response.data.forEach(function (user) {
          cleanName.push(user.name)
        })
        return cleanName
      })
    },
    loadCity: function () {
      var self = this
      var latLngObj = {
        lat: this.latitude,
        lng: this.longitude
      }
      this.$geocoder.setDefaultMode('lat-lng')

      this.$geocoder.send(latLngObj, response => {
        response.results[0].address_components.forEach(function (element) {
          if (element.types.indexOf('locality') > -1) {
            self.city = element.long_name
          }
        })
      })
    },
    close: function () {
      this.dialog = false
      this.$store.dispatch('Device/saveBase64', false)
      this.message = ''
      this.isLoading = false
    },
    save: function () {
      this.isLoading = true

      if (this.reply) {
        this.messageReply()
      } else {
        this.messageCreate()
      }
    },
    messageCreate: function () {
      var self = this

      this.$api.message.save({ 'message': this.message, 'latitude': this.latitude, 'longitude': this.longitude, 'locality': this.city }).then((response) => {
        var message = response.data
        self.$ga.event({
          eventCategory: 'User Engagement',
          eventAction: 'Created a new souvenir',
          eventLabel: 'Posted a new message in the city : ' + this.city,
          eventValue: 0
        })
        if (self.base64Data) {
          var base64 = self.base64Data.split(',')[1]
          this.$api.message.saveFile({ 'id': response.data.id }, { 'raw': base64 }).then((response) => {
            message.media = ['has image']
            event.$emit('newMessagePosted', message)
            self.close()
          }, response => {
            self.errors = (response.data && response.data.error) || []
            self.$store.dispatch('Alert/newAlert', { type: 'error', message: self.$t('errors.critical') })
            self.isLoading = false
          })
        } else {
          event.$emit('newMessagePosted', message)
          self.close()
        }
      }, response => {
        self.errors = (response.data && response.data.error) || []
        self.$store.dispatch('Alert/newAlert', { type: 'error', message: self.$t('errors.critical') })
        self.isLoading = false
      })
    },
    messageReply: function () {
      var self = this

      this.$api.message.reply({ 'id': this.reply }, { 'message': this.message, 'latitude': this.latitude, 'longitude': this.longitude, 'locality': this.city }).then((response) => {
        var message = response.data
        self.$ga.event({
          eventCategory: 'User Engagement',
          eventAction: 'Replied to a souvenir',
          eventLabel: 'Replied to : ' + this.reply,
          eventValue: 0
        })
        if (self.base64Data) {
          var base64 = self.base64Data.split(',')[1]
          this.$api.message.saveFile({ 'id': response.data.id }, { 'raw': base64 }).then((response) => {
            event.$emit('newMessagePosted', message)
            self.close()
          }, response => {
            self.errors = (response.data && response.data.error) || []
            self.$store.dispatch('Alert/newAlert', { type: 'error', message: self.$t('errors.critical') })
            self.isLoading = false
          })
        } else {
          event.$emit('newReplyMessagePosted', message)
          self.close()
        }
      }, response => {
        self.errors = (response.data && response.data.error) || []
        self.$store.dispatch('Alert/newAlert', { type: 'error', message: self.$t('errors.critical') })
        self.isLoading = false
      })
    }
  }
}
</script>

<style>
  .error--text {
  margin-bottom:15px;
  }
</style>
